<template>
  <div>
    <div class="multiple-airports-tag">
      <div>
        <b-tooltip multilined type="is-light" :position="position">
          <b-tag type="is-warning" class="is-small">
            <b-icon icon="alert" size="is-small"></b-icon>
          </b-tag>
          <template v-slot:content>
            <h5 class="is-size-7 has-text-weight-bold has-text-left mb-1">
              Multiple airports
            </h5>
          </template>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MultipleAirportsTag",
  props: {
    type: String,
    position: {
      type: String,
      default: "is-bottom",
    },
  },
  data() {
    return {
      // active: false,
    };
  },
  mounted() {},
  methods: {},
  computed: {},
};
</script>

<style scoped></style>
